import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../../layout/Layout";
import PageBanner from "../../layout/PageBanner";
import { catalogService } from "../../services";
import { Panel, Skeleton } from "../../components/ui";

export default function PromotionDetail() {
  const { id } = useParams();
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    let alive = true;
    catalogService.promotion(id).then((data) => alive && setPromo(data));
    return () => {
      alive = false;
    };
  }, [id]);

  return (
    <Layout>
      <PageBanner
        title="โปรโมชั่น"
        breadcrumb={[{ label: "โปรโมชั่น", to: "/promotions" }, { label: promo?.title || "รายละเอียด" }]}
        seed={5}
      />

      <div className="lucid-container" style={{ marginTop: -30, position: "relative", zIndex: 3, paddingBottom: 40 }}>
        <Panel>
          {!promo ? (
            <Skeleton height={380} />
          ) : (
            <>
              <img
                src={promo.cover}
                alt={promo.title}
                style={{ width: "100%", borderRadius: 14, marginBottom: 22, maxHeight: 420, objectFit: "cover" }}
              />
              <h2 className="lt-panel__title">{promo.title}</h2>
              <p className="lt-helper lt-mb-24">Update {promo.updatedAt}</p>
              <div className="lt-article">
                {promo.content.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
              <Link to="/promotions" className="lt-btn lt-btn--ghost lt-mt-24">
                ← กลับหน้าโปรโมชั่น
              </Link>
            </>
          )}
        </Panel>
      </div>
    </Layout>
  );
}
